import { m } from 'framer-motion';
import Box, { BoxProps } from '@mui/material/Box';

export default function SplashScreen({ sx, ...other }: BoxProps) {
  return (
    <Box
      sx={{
        right: 0,
        width: 1,
        bottom: 0,
        height: 1,
        zIndex: 9998,
        display: 'flex',
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(25, 25, 25, 1)',
        ...sx,
      }}
      {...other}
    >
      <Box
        sx={{
          position: 'absolute',
          width: '1597.269px',
          height: '1597.269px',
          left: '-593.914px',
          top: '-915.315px',
          borderRadius: '1597.269px',
          opacity: 0.12,
          background:
            'radial-gradient(50.5% 50.5% at 51.37% 50.48%, #F1FFAA 6.57%, #A682F7 100%)',
          filter: 'blur(250px)',
          transform: 'rotate(-19.212deg)',
          pointerEvents: 'none',
          zIndex: 0,
        }}
      />
      <>
        <m.div
          animate={{
            scale: [1, 0.9, 0.9, 1, 1],
            opacity: [1, 0.48, 0.48, 1, 1],
          }}
          transition={{
            duration: 2,
            ease: 'easeInOut',
            repeatDelay: 1,
            repeat: Infinity,
          }}
        >
          <Box
            component="div"
            sx={{
              position: 'relative',
              width: '100%',
              height: 33,
              display: 'inline-flex',
              ...sx,
            }}
            {...other}
          >
            <svg width="60" height="60" viewBox="0 0 100 98" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M63.0085 60.6157L97.969 65.8839L78.9703 73.341L75.9276 93.5234L63.0139 60.6157H63.0085Z" fill="white" />
              <path d="M66.2178 46.5393L92.1345 22.4922L86.1174 41.9989L100 56.9604L66.2178 46.5393Z" fill="white" />
              <path d="M57.2237 35.2538L54.5791 0L66.079 16.8623L86.4341 15.3385L57.2237 35.2538Z" fill="white" />
              <path d="M42.7844 35.2538L13.574 15.3385L33.9292 16.8623L45.4237 0L42.7844 35.2538Z" fill="white" />
              <path d="M33.7822 46.5398L0 56.961L13.8826 41.9997L7.86557 22.498L33.7822 46.5451V46.5398Z" fill="white" />
              <path d="M37.0036 60.6157L24.0898 93.5234L21.0472 73.341L2.04834 65.8839L37.0036 60.6157Z" fill="white" />
              <path d="M50.0044 66.8789L67.6784 97.4931L50.0044 87.2865L32.3303 97.4931L50.0044 66.8789Z" fill="white" />
            </svg>
          </Box>
        </m.div>

        <Box
          component={m.div}
          animate={{
            scale: [1.6, 1, 1, 1.6, 1.6],
            rotate: [270, 0, 0, 270, 270],
            opacity: [0.25, 1, 1, 1, 0.25],
            borderRadius: ['25%', '25%', '50%', '50%', '25%'],
          }}
          transition={{ ease: 'linear', duration: 3.2, repeat: Infinity }}
          sx={{
            width: 100,
            height: 100,
            position: 'absolute',
            border: (theme) => `dotted 3px rgba(236, 255, 159, 0.60)`,
          }}
        />

        <Box
          component={m.div}
          animate={{
            scale: [1, 1.2, 1.2, 1, 1],
            rotate: [0, 270, 270, 0, 0],
            opacity: [1, 0.25, 0.25, 0.25, 1],
            borderRadius: ['25%', '25%', '50%', '50%', '25%'],
          }}
          transition={{
            ease: 'linear',
            duration: 3.2,
            repeat: Infinity,
          }}
          sx={{
            width: 120,
            height: 120,
            position: 'absolute',
            border: (theme) => `dotted 8px rgba(236, 255, 159, 0.60)`,
          }}
        />
      </>
    </Box>
  );
}